'use client'

import clsx from 'clsx'
import { useEffect } from 'react'

import { BridgeError } from '@/components/bridge'
import { REQUIRED_PREFIX_PUBLISHERS } from '@/constants/error'
import { sharedWeb } from '@/lib'
import { reportErrorToNewRelic } from '@/utils/newrelic'

import styles from './ErrorPage.module.scss'

interface Props {
  error: Error | BridgeError
}

export default function ErrorPage({ error }: Props) {
  useEffect(() => {
    console.error(error)

    const customAttributes: Record<string, unknown> = {
      errorBoundary: 'ErrorPage',
      errorMessage: error.message,
      errorName: error.name
    }

    if (error instanceof BridgeError) {
      customAttributes.bridgeError = true
      customAttributes.publisher = error.publisher || ''
      customAttributes.subtitle = error.subtitle || ''
    }

    if (error.stack) {
      customAttributes.errorStack = error.stack
    }

    reportErrorToNewRelic(error, customAttributes)
  }, [error])

  const getErrorMessage = () => {
    if (error instanceof BridgeError) {
      return {
        title: '오류가 발생하였습니다.',
        subtitle: error.subtitle || '잠시 후 다시 시도해주세요.',
        publisher: error.publisher || ''
      }
    }

    return {
      title: '오류가 발생하였습니다.',
      subtitle: '잠시 후 다시 시도해주세요.',
      publisher: ''
    }
  }

  const errorMessage = getErrorMessage()

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.content}>
          <p className={styles.title}>{errorMessage.title}</p>
          <p className={styles.subtitle}>{errorMessage.subtitle}</p>
          <div className={styles.formGroup}>
            <div
              className={clsx(
                styles.closeBtn,
                REQUIRED_PREFIX_PUBLISHERS.includes(errorMessage.publisher) ? styles.cookieOvenBtn : styles.defaultBtn
              )}
              onClick={sharedWeb.dismiss}
            >
              확인
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
